import Swiper from 'vux/src/components/swiper/swiper.vue'
import SwiperItem from 'vux/src/components/swiper/swiper-item.vue'

export default {
name: 'companyProfile',
components: {
Swiper,
SwiperItem,
},
data () {
return {
culture1:{
backgroundImage: "url(" + require("../../assets/images/culture1.png") + ")",
backgroundSize: "100%",
},
culture2:{
backgroundImage: "url(" + require("../../assets/images/culture2.png") + ")",
backgroundSize: "100%",
},
culture3:{
backgroundImage: "url(" + require("../../assets/images/culture3.png") + ")",
backgroundSize: "100%",
},
culture4:{
backgroundImage: "url(" + require("../../assets/images/culture4.png") + ")",
backgroundSize: "100%",
},
culture5:{
backgroundImage: "url(" + require("../../assets/images/culture5.png") + ")",
backgroundSize: "100%",
},
}
},
methods: {
myCollect () {
this.$router.push({
path: '/myCollect'
})
}
},
created () {

},
mounted() {

}
}



// WEBPACK FOOTER //
// ./src/views/companyProfile/script.js